export enum VerifyOwnerState {
  SelectOwner = 'SelectOwner',
  VerifyDell = 'VerifyDell',
  SkipVerifyOwner = 'SkipVerifyOwner',
  SetDeal = 'SetDeal',
  VerifyEndUserAndSetOpportunity = 'VerifyEndUserAndSetOpportunity',
  SetOpportunity = 'SetOpportunity',
  VerifyEndUser = 'VerifyEndUser',
}
